<template>
  <div>
    <button class="btn btn-link p-0" type="primary" @click="showModal" :disabled="!medicalData.length">
        {{ medicalData.length ? 'View Medical History' : 'No Medical History'}}
    </button>
    <a-modal
    v-model="visible"
    title="Medical History"
    :width="960"
    style="top: 20px;"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Close</a-button>
      </template>
        <div v-if="medicalData.length">
            <div class="row" v-for="(data, arrayIndex) in medicalInfo" :key="arrayIndex">
                <div class="col-6 col-md-4 pb-3" v-for="(item, index) in data" :key="index">
                    <div class="mb-1">{{index}} :</div>
                    <div>
                        <strong class="h5 font-weight-bold">{{item}}</strong>
                    </div>
                </div>
                <a-divider v-if="arrayIndex < medicalData.length - 1" class="mb-3"/>
            </div>
        </div>
        <div v-else>
            <div class="row justify-content-center">
                <div class="col py-5 text-center bg-light">
                    <p class="mb-0">No medical data found!</p>
                </div>
            </div>
        </div>
    </a-modal>
  </div>
</template>

<script>
import { medicalInfo } from './data'
export default {
  name: 'MedicalHistory',
  props: ['medicalData'],
  data: function() {
    return {
      loading: false,
      visible: false,
      medicalInfo: [],
    }
  },
  methods: {
    showModal() {
      this.visible = true
      this.medicalInfo = medicalInfo(this.medicalData)
    },

    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>
